import Vue from 'vue'
import store from '~/store'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const languageFiles = import.meta.glob('../lang/*.json')
const fallbackLocale = 'en'

const i18n = new VueI18n({
  locale: fallbackLocale,
  fallbackLocale,
  messages: {}
})

/**
 * @param {String} locale
 */
export async function loadMessages (locale) {
  if (Object.keys(i18n.getLocaleMessage(locale)).length === 0) {
    const loadLanguage = languageFiles[`../lang/${locale}.json`]

    if (!loadLanguage) {
      throw new Error(`Language file not found for locale [${locale}]`)
    }

    const messages = await loadLanguage()
    i18n.setLocaleMessage(locale, messages.default || messages)
  }

  if (i18n.locale !== locale) {
    i18n.locale = locale
  }
}

;(async function () {
  const locale = store.getters['lang/locale']

  await loadMessages(fallbackLocale)
  await loadMessages(locale)
})()

export default i18n
